
document.addEventListener("DOMContentLoaded", function () {
  const statsTrack = document.getElementById("statsTrack");
  const paginationDots = document.querySelectorAll(
    ".stats-pagination .pagination-dot"
  );
  const statCards = document.querySelectorAll(".stat-card");

  // Stop if slider doesn't exist or only 1 slide
  if (!statsTrack || statCards.length <= 1) return;

  let currentIndex = 0;
  let touchStartX = 0;
  let touchEndX = 0;

  const updateCarousel = () => {
    const slideWidth = statCards[0].offsetWidth;

    const gap =
      parseInt(window.getComputedStyle(statsTrack).gap) || 0;

    const offset = currentIndex * (slideWidth + gap);

    statsTrack.style.transform = `translateX(-${offset}px)`;

    paginationDots.forEach((dot, idx) => {
      dot.classList.toggle("active", idx === currentIndex);
    });
  };

  const moveToSlide = (index) => {
    currentIndex = Math.max(
      0,
      Math.min(index, paginationDots.length - 1)
    );
    updateCarousel();
  };

  const moveNext = () => {
    if (currentIndex < paginationDots.length - 1) {
      currentIndex++;
      updateCarousel();
    }
  };

  const movePrev = () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  };

  // Pagination dot click
  paginationDots.forEach((dot, idx) => {
    dot.addEventListener("click", () => {
      moveToSlide(idx);
    });
  });

  // Touch swipe start
  statsTrack.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.changedTouches[0].screenX;
    },
    false
  );

  // Touch swipe end
  statsTrack.addEventListener(
    "touchend",
    (e) => {
      touchEndX = e.changedTouches[0].screenX;

      const diff = touchStartX - touchEndX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          moveNext(); // swipe left
        } else {
          movePrev(); // swipe right
        }
      }
    },
    false
  );

  // Keyboard navigation
  document.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") movePrev();
    if (e.key === "ArrowRight") moveNext();
  });

  // Recalculate on window resize
  window.addEventListener("resize", updateCarousel);

  // Initial setup
  updateCarousel();
});
